import Cookies from 'js-cookie'

export const AUTH_TOKEN_COOKIE_KEY = 'token'
export const AUTH_USER_ID_COOKIE_KEY = 'userId'
export const AUTH_USER_INFO_STORAGE_KEY = 'userInfo'

/**
 * 判断字符串是否为看起来合法的 JWT 格式。
 *
 * @param token 待判断的令牌
 * @returns 是否满足三段式 JWT 格式
 */
export function isLikelyJwtToken(token?: string | null): boolean {
  if (!token) {
    return false
  }

  const segments = token
    .trim()
    .split('.')
    .filter(Boolean)

  return segments.length === 3
}

/**
 * 获取当前持久化的访问令牌。
 *
 * @returns Cookie 中保存的令牌
 */
export function getStoredToken(): string {
  return Cookies.get(AUTH_TOKEN_COOKIE_KEY) || ''
}

/**
 * 获取当前持久化的用户 ID。
 *
 * @returns Cookie 中保存的用户 ID
 */
export function getStoredUserId(): string {
  return Cookies.get(AUTH_USER_ID_COOKIE_KEY) || ''
}

/**
 * 清理本地持久化的登录态。
 */
export function clearAuthStorage(): void {
  Cookies.remove(AUTH_TOKEN_COOKIE_KEY)
  Cookies.remove(AUTH_USER_ID_COOKIE_KEY)
  localStorage.removeItem(AUTH_USER_INFO_STORAGE_KEY)
}

/**
 * 判断当前本地登录态是否完整可用。
 *
 * @returns 是否具备可用的 token 与用户 ID
 */
export function hasValidStoredSession(): boolean {
  const token = getStoredToken()
  const userId = getStoredUserId()
  return isLikelyJwtToken(token) && !!userId
}
